/* eslint import/prefer-default-export: 0 */

import remote from './remote';

export function getStaticContent(type, query = {}) {
  return remote.get(`content/${type}`, query);
}
